<template>
  <v-container fluid>
    <a-form layout="vertical">
      <a-row :gutter="8">
        <a-col :span="24" :xxl="3" :xl="4" :lg="12" :md="12">
          <a-form-item label="派车单号">
            <a-textarea v-model="queryForm.nos" placeholder="派车单号" :auto-size="{ minRows: 6, maxRows: 6 }"></a-textarea>
          </a-form-item>
        </a-col>
        <a-col :span="24" :xxl="3" :xl="4" :lg="12" :md="12">
          <a-form-item label="平台单号">
            <a-textarea v-model="queryForm.platform_no" placeholder="平台单号"
              :auto-size="{ minRows: 6, maxRows: 6 }"></a-textarea>
          </a-form-item>
        </a-col>
        <a-col :span="24" :xxl="18" :xl="16" :lg="24" :md="24">
          <a-row :gutter="8">
            <a-col :span="24" :xxl="5" :xl="7" :lg="8" :md="8">
              <a-form-item label="封车日期">
                <a-range-picker v-model="queryForm.day_range" :mode="['date', 'date']" :placeholder="['开始日期', '结束日期']"
                  :locale="locale" :allowClear="false" format="YYYY-MM-DD" valueFormat="YYYY-MM-DD"
                  style="width:100%;" />
              </a-form-item>
            </a-col>
            <a-col :span="24" :xxl="2" :xl="4" :lg="4" :md="4">
              <a-form-item label="车型">
                <a-select v-model="queryForm.vehicle_type" :options="vehicle_types" :allowClear="true" placeholder="请选择"
                  style="width:100%;">
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="24" :xxl="2" :xl="4" :lg="4" :md="4">
              <a-form-item label="车牌号">
                <a-input v-model="queryForm.vehicle_number" placeholder="车牌号" style="width:100%;" />
              </a-form-item>
            </a-col>
            <a-col :span="24" :xxl="2" :xl="4" :lg="4" :md="4">
              <a-form-item label="一干/二干">
                <a-select v-model="queryForm.postroutelevel" :options="[
                  { label: '一干', value: '一级' },
                  { label: '二干', value: '二级' }
                ]" :allowClear="true" placeholder="请选择" style="width:100%;">
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="24" :xxl="2" :xl="4" :lg="4" :md="4">
              <a-form-item label="单程/往返">
                <a-select v-model="queryForm.transport_kind" :options="[
                  { label: '单程', value: '单程' },
                  { label: '往返', value: '往返' }
                ]" :allowClear="true" placeholder="请选择" style="width:100%;">
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="24" :xxl="3" :xl="4" :lg="4" :md="6">
              <a-form-item label="邮局">
                <a-select v-model="queryForm.postofficeid" :options="postoffices" :allowClear="true" placeholder="请选择"
                  style="width:100%;">
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="24" :xxl="3" :xl="4" :lg="4" :md="6">
              <a-form-item label="线路">
                <a-input v-model="queryForm.postline" placeholder="线路" style="width:100%;" />
              </a-form-item>
            </a-col>
            <a-col :span="24" :xxl="3" :xl="5" :lg="6" :md="6">
              <a-form-item label="状态">
                <a-select v-model="queryForm.self_bill_state" :options="self_bill_states" :allowClear="true"
                  placeholder="请选择" style="width:100%;">
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="24" :xxl="3" :xl="5" :lg="4" :md="6">
              <a-form-item label="所属公司">
                <a-select v-model="queryForm.corp" :options="corps" :allowClear="true" placeholder="请选择"
                  style="width:100%;">
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="24" :xxl="3" :xl="5" :lg="4" :md="6">
              <a-form-item label="车辆归属">
                <a-select v-model="queryForm.own_type" :options="own_types" :allowClear="true" placeholder="请选择"
                  style="width:100%;">
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="24" :xxl="3" :xl="5" :lg="4" :md="6">
              <a-form-item label="所属标段">
                <a-select v-model="queryForm.section" :options="sections" :allowClear="true" placeholder="请选择"
                  style="width:100%;">
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="24" :xxl="8" :xl="16" :lg="12" :md="12">
              <a-form-item label=".">
                <a-space>
                  <a-button type="primary" @click="getdata()">查询</a-button>
                  <a-dropdown>
                    <a-button class="ant-dropdown-link" @click="e => e.preventDefault()">
                      下载
                      <a-icon type="down" />
                    </a-button>
                    <a-menu slot="overlay" @click="(e) => {
                      if (e.key === 'download') download();
                      if (e.key === 'download2') download2();
                    }">
                      <a-menu-item key="download">
                        <a href="javascript:;">下载自营账单</a>
                      </a-menu-item>
                      <a-menu-item key="download2">
                        <a href="javascript:;">下载合并账单</a>
                      </a-menu-item>
                    </a-menu>
                  </a-dropdown>
                  <a-button v-if="uploadable" @click="() => $refs.uploadRef1.showupload()" class="btn-success">
                    <a-icon type="upload" />上传自营账单
                  </a-button>
                  <a-button v-if="uploadable" @click="() => $refs.uploadRef2.showupload()" class="btn-cyan">
                    <a-icon type="upload" />上传蜂羽账单
                  </a-button>
                </a-space>
              </a-form-item>
            </a-col>
          </a-row>
        </a-col>
      </a-row>
    </a-form>
    <p v-if="total_freight2" class="error--text text-h6">
      合计：
      <span>自有成本
        <span class="success--text">
          {{ total_freight2.real_freight_1 }}
        </span>
      </span>,
      <span>包车成本
        <span class="success--text">
          {{ total_freight2.real_freight_3 }}
        </span>
      </span>,
      <span> 平台总价
        <span class="success--text">
          {{ total_freight2.real_freight2 }}
        </span>
        ({{ total_freight2.real_freight2_947 }})
      </span>,
      <span> 油卡金额
        <span class="success--text">
          {{ total_freight2.oilcard_fee }}
        </span>
        ({{ total_freight2.oilcard_fee_947 }})
      </span>,
      <span> 卸货到付
        <span class="success--text">
          {{ total_freight2.delivery_discharge_fee }}
        </span>
        ({{ total_freight2.delivery_discharge_fee_947 }})
      </span>,
      <span> 回单押金
        <span class="success--text">
          {{ total_freight2.receipt_deposit }}
        </span>
        ({{ total_freight2.receipt_deposit_947 }})
      </span>,
      <span> 考核 ({{ total_freight2.check_amount2 }}) </span>
    </p>
    <p v-else-if="total_freight" class="error--text text-h6">
      合计：
      <span>自有成本
        <span class="success--text">
          {{ total_freight.real_freight_1 }}
        </span>
      </span>,
      <span>包车成本
        <span class="success--text">
          {{ total_freight.real_freight_3 }}
        </span>
      </span>,
      <span> 平台总价
        <span class="success--text">
          {{ total_freight.real_freight2 }}
        </span>
        ({{ total_freight.real_freight2_947 }})
      </span>,
      <span> 油卡金额
        <span class="success--text">
          {{ total_freight.oilcard_fee }}
        </span>
        ({{ total_freight.oilcard_fee_947 }})
      </span>,
      <span> 卸货到付
        <span class="success--text">
          {{ total_freight.delivery_discharge_fee }}
        </span>
        ({{ total_freight.delivery_discharge_fee_947 }})
      </span>,
      <span> 回单押金
        <span class="success--text">
          {{ total_freight.receipt_deposit }}
        </span>
        ({{ total_freight.receipt_deposit_947 }})
      </span>,
      <span> 考核 ({{ total_freight.check_amount2 }}) </span>
    </p>
    <v-card tile>
      <a-table size="small" :columns="headers" :data-source="list" row-key="_id" :pagination="false"
        :locale="{ emptyText: '暂无数据' }" :scroll="{ x: width, y: height }" :row-selection="{
          selectedRowKeys,
          onChange: (keys) => selectedRowKeys = keys,
          // getCheckboxProps: (record) => {
          //   return {
          //     props: {
          //       disabled: !record.generateable,
          //     }
          //   }
          // }
        }">
        <template slot="title">
          <div class="d-flex">
            <a-space v-if="editable">
              <a-button type="primary" :disabled="selectedRowKeys.length === 0" @click="makepayable">
                生成应付账款
              </a-button>
              <a-button type="primary" :disabled="selectedRowKeys.length === 0" @click="showbulkedit(1)">
                油卡支付
              </a-button>
              <a-button type="primary" :disabled="selectedRowKeys.length === 0" @click="showbulkedit(2)">
                到付款支付
              </a-button>
              <a-button type="primary" :disabled="selectedRowKeys.length === 0" @click="showbulkedit(3)">
                回单支付
              </a-button>
            </a-space>
            <v-spacer></v-spacer>
            <div class="d-flex align-center pl-2">
              <div class="pages">
                <span>共 {{ length }} 页 / {{ count }} 条数据</span>
                <v-menu bottom offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn small outlined v-bind="attrs" v-on="on" class="ml-2 grey lighten-3">
                      {{ limit }}/页
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item v-for="(item, index) in pages" @click="limit = item.value" :key="index">
                      <v-list-item-title>{{ item.value }}/页</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </div>
              <v-pagination v-if="length > 1" v-model="page" :page="page" :length="length" total-visible="10" />
            </div>
          </div>
        </template>
        <template slot="AH">
          <p style="font-size:12px;">流水号日期</p>
          <p style="font-size:12px;">封车日期</p>
        </template>
        <template slot="A" slot-scope="text, record">
          <p style="font-size:12px;">{{ record.serial_day }}</p>
          <p style="font-size:12px;">{{ record.block_day }}</p>
        </template>
        <template slot="BH">
          <p style="font-size:12px;">班次</p>
          <p style="font-size:12px;">邮路名称</p>
          <p style="font-size:12px;">所属标段</p>
        </template>
        <template slot="B" slot-scope="text, record">
          <p style="font-size:12px;">{{ record.shift_order }}</p>
          <p style="font-size:12px;">{{ record.postroute }}</p>
          <p v-if="record.section_name" :style="{
            'color': $utils.textToBgColor(record.section_name.replace('标段', '')),
            'font-size': '12px',
          }">{{ record.section_name }}</p>
        </template>
        <template slot="CH">
          <p style="font-size:12px;">车牌号</p>
          <p style="font-size:12px;">挂厢号</p>
        </template>
        <template slot="C" slot-scope="text, record">
          <p style="font-size:12px;">{{ record.vehicle_number }}</p>
          <p style="font-size:12px;">{{ record.vehicle_gnumber }}</p>
        </template>
        <template slot="DH">
          <p style="font-size:12px;">车长</p>
          <p style="font-size:12px;">吨位</p>
        </template>
        <template slot="D" slot-scope="text, record">
          <p style="font-size:12px;">{{ record.vehicle_length || '-' }}</p>
          <p style="font-size:12px;">{{ record.request_weight }}</p>
        </template>
        <template slot="EH">
          <p style="font-size:12px;">车辆归属</p>
        </template>
        <template slot="E" slot-scope="text, record">
          <p style="font-size:12px;" class="error--text">{{ record.own_type_name }}</p>
          <p style="font-size:12px;">{{ record.platformbillcreator }}</p>
        </template>
        <template slot="FH">
          <p style="font-size:12px;">司机姓名</p>
          <p style="font-size:12px;">司机电话</p>
        </template>
        <template slot="F" slot-scope="text, record">
          <p style="font-size:12px;">{{ record.driver_name }}</p>
          <p style="font-size:12px;">{{ record.driver_mobile }}</p>
        </template>
        <template slot="GH">
          <p style="font-size:12px;">封车时间</p>
          <p style="font-size:12px;">出围栏时间</p>
        </template>
        <template slot="G" slot-scope="text, record">
          <p style="font-size:12px;">{{ record.block_time || '-' }}</p>
          <p style="font-size:12px;">{{ record.out_time || '-' }}</p>
        </template>
        <template slot="HH">
          <p style="font-size:12px;">入围栏时间</p>
          <p style="font-size:12px;">入局扫描时间</p>
          <p style="font-size:12px;">解车时间</p>
        </template>
        <template slot="H" slot-scope="text, record">
          <p style="font-size:12px;">{{ record.in_time || '-' }}</p>
          <p style="font-size:12px;">{{ record.scan_time || '-' }}</p>
          <p style="font-size:12px;">{{ record.unblock_time || '-' }}</p>
        </template>
        <template slot="IH">
          <p style="font-size:12px;">流水号</p>
          <p style="font-size:12px;">派车单号</p>
        </template>
        <template slot="I" slot-scope="text, record">
          <p style="font-size:12px;">{{ record.serial_no }}</p>
          <p style="font-size:12px;">{{ record.dispatch_no }}</p>
          <a-space
            v-if="username === 'root' && record.billcount > 1 && (record.own_type === 1 || record.own_type === 3)">
            <v-btn icon outlined x-small color="success" @click="() => {
              queryForm.nos = record.dispatch_no;
              getdata();
            }">
              <v-icon x-small>mdi-plus</v-icon>
            </v-btn>
            <v-btn icon outlined x-small color="error" @click="() => {
              queryForm.nos = '';
              getdata();
            }">
              <v-icon x-small>mdi-minus</v-icon>
            </v-btn>
          </a-space>
        </template>
        <template slot="JH">
          <p style="font-size:12px;">车辆成本</p>
          <p style="font-size:12px;">司机成本</p>
        </template>
        <template slot="J" slot-scope="text, record">
          <p style="font-size:12px;">{{ record.vcost }}</p>
          <p style="font-size:12px;">{{ record.dcost }}</p>
        </template>
        <template slot="KH">
          <p style="font-size:12px;">电费</p>
          <p style="font-size:12px;">油费</p>
          <p style="font-size:12px;">过路费</p>
        </template>
        <template slot="K" slot-scope="text, record">
          <p style="font-size:12px;">{{ record.ecost }}</p>
          <p style="font-size:12px;">{{ record.ocost }}</p>
          <p style="font-size:12px;">{{ record.rcost }}</p>
        </template>
        <template slot="LH">
          <span style="font-size:12px;">收款人</span>
        </template>
        <template slot="L" slot-scope="text, record">
          <a-input v-if="record.editable" v-model="record.paytarget" size="small"
            @blur="savepaytarget(record)"></a-input>
          <span v-else>{{ record.paytarget }}</span>
        </template>
        <template slot="M0H">
          <span style="font-size:12px;">生成应付状态</span>
        </template>
        <template slot="M0" slot-scope="text, record">
          <template v-if="record.fee_request_billid">
            <p style="font-size:12px;" class="error--text">
              运费已申请({{ record.fee_request_billno }})
            </p>
            <p style="font-size:12px;" class="error--text">
              {{ record.fee_request_time }}
            </p>
          </template>
          <template v-if="record.oil_request_billid">
            <p style="font-size:12px;" class="error--text">
              油卡已申请({{ record.oil_request_billno }})
            </p>
            <p style="font-size:12px;" class="error--text">
              {{ record.oil_request_time }}
            </p>
          </template>
          <template v-if="record.receipt_request_billid">
            <p style="font-size:12px;" class="error--text">
              回单已申请({{ record.receipt_request_billno }})
            </p>
            <p style="font-size:12px;" class="error--text">
              {{ record.receipt_request_time }}
            </p>
          </template>
        </template>
        <template slot="MH">
          <p style="font-size:12px;">平台</p>
          <p style="font-size:12px;">平台单号</p>
          <p style="font-size:12px;">税率</p>
        </template>
        <template slot="M" slot-scope="text, record">
          <p style="font-size:12px;">
            {{ record.platform === '其他' ? `${record.platform_name || record.platform}` : record.platform }}
          </p>
          <p style="font-size:12px;">{{ record.platform_no }}</p>
          <p v-if="record.platform && record.platform_rate" style="font-size:12px;">
            <template v-if="platformrateform._id === record._id">
              <a-input v-model="platformrateform.platform_rate" size="small" @blur="savePlatformRate"></a-input>
            </template>
            <a v-else-if="record.editable" href="javascript:;" :class="{
              'error--text': true,
              'underline click': username === 'root'
            }" @click="editPlatformRate(record)">
              {{ record.platform_rate }}%
            </a>
            <span v-else>
              {{ record.platform_rate }}%
            </span>
          </p>
        </template>
        <template slot="NH">
          <p style="font-size:12px;">平台总价</p>
          <p style="font-size:12px;">平台总价(含税)</p>
        </template>
        <template slot="N" slot-scope="text, record">
          <p class="success--text font-weight-bold" style="font-size:12px;">
            {{ record._real_freight2 }}
          </p>
          <p class="error--text font-weight-bold" style="font-size:12px;">
            {{ record._real_freight2_947 }}
          </p>
        </template>
        <template slot="OH">
          <span style="font-size:12px;">考核金额</span>
        </template>
        <template slot="O" slot-scope="text, record">
          <span style="font-size:12px;">{{ record.check_amount2 }}</span>
        </template>
        <template slot="PH">
          <span style="font-size:12px;">油卡金额</span>
        </template>
        <template slot="P" slot-scope="text, record">
          <p v-if="record.oilcard_fee > 0" style="font-size:12px;">{{ record.oilcard_fee }}</p>
          <p v-if="record.oilcard_fee_947 > 0" class="error--text font-weight-bold" style="font-size:12px;">
            {{ record.oilcard_fee_947 }}
          </p>
          <p v-if="record.oilcard_fee && record.oilcard_type" style="font-size:12px;">
            <template v-if="oilcardrateform._id === record._id">
              <v-select v-model="oilcardrateform.oilcard_type" :items="record.oilcard_types" label="油卡类型"
                no-data-text="无" dense outlined :menu-props="{ bottom: true, offsetY: true }" hide-details>
              </v-select>
              <a-space>
                <v-btn tile text small color="primary" @click="saveOilcardRate"> 保存 </v-btn>
                <v-btn tile text small color="gray" @click="cancelSaveOilcardRate"> 取消 </v-btn>
              </a-space>
            </template>
            <a v-else-if="record.editable" href="javascript:;" :class="{
              'error--text': true,
              'underline click': username === 'root'
            }" @click="editOilcardRate(record)">
              {{ record.oilcard_type }} {{ record.oilcard_rate }}%
            </a>
            <span v-else>
              {{ record.oilcard_type }} {{ record.oilcard_rate }}%
            </span>
          </p>
        </template>
        <template slot="QH">
          <span style="font-size:12px;">油卡日期</span>
        </template>
        <template slot="Q" slot-scope="text, record">
          <span v-if="record.oilcard_day" class="success--text font-weight-bold" style="font-size:12px;">
            {{ record.oilcard_day }}
          </span>
        </template>
        <template slot="RH">
          <span style="font-size:12px;">卸货到付</span>
        </template>
        <template slot="R" slot-scope="text, record">
          <p v-if="record.delivery_discharge_fee > 0" class="success--text font-weight-bold" style="font-size:12px;">
            {{ record._delivery_discharge_fee }}
          </p>
          <p v-if="record.delivery_discharge_fee_947 > 0" class="error--text font-weight-bold" style="font-size:12px;">
            {{ record._delivery_discharge_fee_947 }}
          </p>
        </template>
        <template slot="SH">
          <span style="font-size:12px;">到付申请日期</span>
        </template>
        <template slot="S" slot-scope="text, record">
          <span class="error--text font-weight-bold" style="font-size:12px;">
            {{ record.fee_request_day }}
          </span>
        </template>
        <template slot="TH">
          <span style="font-size:12px;">到付付款日期</span>
        </template>
        <template slot="T" slot-scope="text, record">
          <span v-if="record.fee_pay_day" class="error--text font-weight-bold" style="font-size:12px;">
            {{ record.fee_pay_day }}
          </span>
        </template>
        <template slot="UH">
          <span style="font-size:12px;">回单押金</span>
        </template>
        <template slot="U" slot-scope="text, record">
          <p v-if="record.receipt_deposit > 0" class="success--text font-weight-bold" style="font-size:12px;">
            {{ record._receipt_deposit }}
          </p>
          <p v-if="record.receipt_deposit_947 > 0" class="error--text font-weight-bold" style="font-size:12px;">
            {{ record._receipt_deposit_947 }}
          </p>
        </template>
        <template slot="VH">
          <span style="font-size:12px;">GPS</span>
        </template>
        <template slot="V" slot-scope="text, record">
          <span style="font-size:12px;">{{ record.gps_no }}</span>
        </template>
        <template slot="WH">
          <span style="font-size:12px;">GPS回单回收日期</span>
        </template>
        <template slot="W" slot-scope="text, record">
          <span class="primary--text font-weight-bold" style="font-size:12px;">
            {{ record.receipt_return_day }}
          </span>
        </template>
        <template slot="XH">
          <span style="font-size:12px;">回单申请日期</span>
        </template>
        <template slot="X" slot-scope="text, record">
          <span class="primary--text font-weight-bold" style="font-size:12px;">
            {{ record.receipt_request_day }}
          </span>
        </template>
        <template slot="YH">
          <span style="font-size:12px;">回单付款日期</span>
        </template>
        <template slot="Y" slot-scope="text, record">
          <span v-if="receipt_pay_day" class="primary--text font-weight-bold" style="font-size:12px;">
            {{ record.receipt_pay_day }}
          </span>
        </template>
        <template slot="ZH">
          <span style="font-size:12px;">付款信息</span>
        </template>
        <template slot="Z" slot-scope="text, record">
          <span style="font-size:12px;">
            {{ record.pay_info }}
          </span>
        </template>
        <template slot="Z1H">
          <span style="font-size:12px;">备注</span>
        </template>
        <template slot="Z1" slot-scope="text, record">
          <span style="font-size:12px;">
            {{ record.selfremark }}
          </span>
        </template>
        <template slot="update_time" slot-scope="text, record">
          <p>{{ record.update_time }}</p>
          <p>{{ record.update_by }}</p>
        </template>
        <template slot="action" slot-scope="text, record">
          <div v-if="record.editable" class="d-flex flex-column">
            <a href="javascript:;" style="font-size:12px;" class="success--text" @click="showedit(record)"> 编辑 </a>
          </div>
          <div class="d-flex flex-column">
            <a v-if="(username === 'root' || username === 'wqx') && record.unlockable" href="javascript:;"
              style="font-size:12px;" class="error--text" @click="unlock(record._id)"> 解锁 </a>
            <span v-else class="error--text" style="font-size:11px;">已锁定</span>
          </div>
        </template>
      </a-table>
      <v-pagination v-if="length > 1" v-model="page" :page="page" :length="length" total-visible="10" />
    </v-card>
    <v-dialog v-model="billModel" persistent max-width="750px">
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-card>
          <v-card-title class="grey lighten-4 pa-2 text-subtitle-1 mb-4 d-flex justify-space-between">
            修改自营账单
            <v-icon @click="cancelupdate">mdi-close</v-icon>
          </v-card-title>
          <v-card-text>
            <v-container fluid style="max-height:600px;overflow-y:auto;">
              <v-row>
                <v-col cols="12" class="error--text text-body-1">
                  <a-row>
                    <a-col :span="8">
                      邮路：{{ billForm.postroute }}
                    </a-col>
                    <a-col :span="8">
                      派车单号：{{ billForm.dispatch_no }}
                    </a-col>
                    <a-col :span="8">
                      流水号：{{ billForm.serial_no }}
                    </a-col>
                  </a-row>
                  <a-row>
                    <a-col :span="8">
                      车牌号：{{ billForm.vehicle_number }}
                    </a-col>
                    <a-col :span="8">
                      挂厢号：{{ billForm.vehicle_gnumber }}
                    </a-col>
                    <a-col :span="8">
                      司机：{{ billForm.driver_name }}/{{ billForm.driver_mobile }}
                    </a-col>
                  </a-row>
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field v-model="billForm.check_aging" label="考核时效" type="number" outlined dense>
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="3">
                  <v-select v-model="billForm.platform" :items="platforms" :rules="[vrules.required]" no-data-text="无"
                    dense outlined :menu-props="{ bottom: true, offsetY: true }" @change="changePlatform">
                    <template v-slot:label>
                      平台 <span class="red--text">*</span>
                    </template>
                  </v-select>
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field v-if="billForm.platform === '其他'" v-model="billForm.platform_name"
                    :rules="[vrules.required]" outlined dense>
                    <template v-slot:label>
                      平台名称 <span class="red--text">*</span>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field v-if="billForm.platform === '其他'" v-model="billForm.platform_rate"
                    :rules="[vrules.required]" type="number" outlined dense>
                    <template v-slot:label>
                      结算系数 <span class="red--text">*</span>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="12" v-if="billForm.platform === '其他'" class="error--text">
                  平台税点和结算系数转换规则: 例如平台税点5.3%，则系数为 0.947 = 1-0.053
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field v-model="billForm.platform_no" label="平台单号" outlined dense>
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field v-model="billForm.real_freight2" label="平台总价" type="number" outlined dense>
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field v-model="billForm.check_amount2" label="考核金额" type="number" outlined dense>
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field v-model="billForm.oilcard_fee" label="油卡金额" type="number" outlined dense>
                  </v-text-field>
                </v-col>
                <v-col v-if="oilcard_types.length > 0" cols="12" md="4">
                  <v-select v-model="billForm.oilcard_type" :items="oilcard_types" label="油卡类型" no-data-text="无" dense
                    outlined :menu-props="{ bottom: true, offsetY: true }">
                  </v-select>
                </v-col>
                <v-col cols="12" md="4">
                  <v-menu ref="oilcard_day" v-model="oilcard_day" :close-on-content-click="false"
                    :return-value.sync="billForm.oilcard_day" transition="scale-transition" min-width="auto" offset-y>
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="billForm.oilcard_day" label="油卡日期" append-icon="mdi-calendar" readonly
                        v-bind="attrs" v-on="on" dense outlined>
                      </v-text-field>
                    </template>
                    <v-date-picker v-model="billForm.oilcard_day" no-title value="YYYY-mm-dd" scrollable locale="zh-cn"
                      @input="() => { $refs.oilcard_day.save(billForm.oilcard_day); oilcard_day = false; }"></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field v-model="billForm.delivery_discharge_fee" label="卸货到付" type="number" outlined dense>
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-menu ref="fee_request_day" v-model="fee_request_day" :close-on-content-click="false"
                    :return-value.sync="billForm.fee_request_day" transition="scale-transition" min-width="auto"
                    offset-y>
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="billForm.fee_request_day" label="到付申请日期" append-icon="mdi-calendar"
                        readonly v-bind="attrs" v-on="on" dense outlined>
                      </v-text-field>
                    </template>
                    <v-date-picker v-model="billForm.fee_request_day" no-title value="YYYY-mm-dd" scrollable
                      locale="zh-cn"
                      @input="() => { $refs.fee_request_day.save(billForm.fee_request_day); fee_request_day = false; }"></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" md="4">
                  <v-menu ref="fee_pay_day" v-model="fee_pay_day" :close-on-content-click="false"
                    :return-value.sync="billForm.fee_pay_day" transition="scale-transition" min-width="auto" offset-y>
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="billForm.fee_pay_day" label="到付付款日期" append-icon="mdi-calendar" readonly
                        v-bind="attrs" v-on="on" dense outlined>
                      </v-text-field>
                    </template>
                    <v-date-picker v-model="billForm.fee_pay_day" no-title value="YYYY-mm-dd" scrollable locale="zh-cn"
                      @input="() => { $refs.fee_pay_day.save(billForm.fee_pay_day); fee_pay_day = false; }"></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field v-model="billForm.receipt_deposit" label="回单押金" type="number" outlined dense>
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field v-model="billForm.gps_no" label="GPS" outlined dense>
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-menu ref="receipt_return_day" v-model="receipt_return_day" :close-on-content-click="false"
                    :return-value.sync="billForm.receipt_return_day" transition="scale-transition" min-width="auto"
                    offset-y>
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="billForm.receipt_return_day" label="GPS回单回收日期" append-icon="mdi-calendar"
                        readonly v-bind="attrs" v-on="on" dense outlined>
                      </v-text-field>
                    </template>
                    <v-date-picker v-model="billForm.receipt_return_day" no-title value="YYYY-mm-dd" scrollable
                      locale="zh-cn"
                      @input="() => { $refs.receipt_return_day.save(billForm.receipt_return_day); receipt_return_day = false; }"></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" md="4">
                  <v-menu ref="receipt_request_day" v-model="receipt_request_day" :close-on-content-click="false"
                    :return-value.sync="billForm.receipt_request_day" transition="scale-transition" min-width="auto"
                    offset-y>
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="billForm.receipt_request_day" label="回单申请日期" append-icon="mdi-calendar"
                        readonly v-bind="attrs" v-on="on" dense outlined>
                      </v-text-field>
                    </template>
                    <v-date-picker v-model="billForm.receipt_request_day" no-title value="YYYY-mm-dd" scrollable
                      locale="zh-cn"
                      @input="() => { $refs.receipt_request_day.save(billForm.receipt_request_day); receipt_request_day = false; }"></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" md="4">
                  <v-menu ref="receipt_pay_day" v-model="receipt_pay_day" :close-on-content-click="false"
                    :return-value.sync="billForm.receipt_pay_day" transition="scale-transition" min-width="auto"
                    offset-y>
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="billForm.receipt_pay_day" label="回单付款日期" append-icon="mdi-calendar"
                        readonly v-bind="attrs" v-on="on" dense outlined>
                      </v-text-field>
                    </template>
                    <v-date-picker v-model="billForm.receipt_pay_day" no-title value="YYYY-mm-dd" scrollable
                      locale="zh-cn"
                      @input="() => { $refs.receipt_pay_day.save(billForm.receipt_pay_day); receipt_pay_day = false; }"></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" :md="oilcard_types.length > 0 ? 4 : 8">
                  <v-text-field v-model="billForm.L" label="收款人" outlined dense>
                  </v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field v-model="billForm.payinfo" label="付款信息" outlined dense>
                  </v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-textarea v-model="billForm.selfremark" label="备注" rows="2" outlined></v-textarea>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-checkbox v-if="billForm.transport_kind === '往返'" v-model="billForm.fix_cost" label="固定成本，往返不自动减半"
              error></v-checkbox>
            <v-spacer></v-spacer>
            <v-btn tile color="primary" :disabled="!valid" @click="updatebill">保存</v-btn>
            <v-btn tile @click="cancelupdate">关闭</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
    <v-dialog v-model="bulkModel" persistent max-width="400px">
      <v-form ref="bulkform">
        <v-card>
          <v-card-title class="grey lighten-4 pa-2 text-subtitle-1 mb-4 d-flex justify-space-between">
            {{ bulkForm.type === 1 ? '油卡支付' : '' }}
            {{ bulkForm.type === 2 ? '到付款支付' : '' }}
            {{ bulkForm.type === 3 ? '回单支付' : '' }}
            <v-icon @click="cancelbulkupdate">mdi-close</v-icon>
          </v-card-title>
          <v-card-text>
            <v-container fluid>
              <v-row>
                <v-col v-if="bulkForm.type === 1" cols="12">
                  <v-text-field v-model="bulkForm.fee" outlined dense readonly>
                    <template v-slot:label>
                      <span class="red--text">油卡金额 *</span>
                    </template>
                  </v-text-field>
                  <v-menu ref="oilcard_day" v-model="oilcard_day" :close-on-content-click="false"
                    :return-value.sync="bulkForm.oilcard_day" transition="scale-transition" min-width="auto" offset-y>
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="bulkForm.oilcard_day" label="油卡日期" append-icon="mdi-calendar" readonly
                        v-bind="attrs" v-on="on" dense outlined>
                      </v-text-field>
                    </template>
                    <v-date-picker v-model="bulkForm.oilcard_day" no-title value="YYYY-mm-dd" scrollable locale="zh-cn"
                      @input="() => { $refs.oilcard_day.save(bulkForm.oilcard_day); oilcard_day = false; }"></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col v-if="bulkForm.type === 2" cols="12">
                  <v-text-field v-model="bulkForm.fee" outlined dense readonly>
                    <template v-slot:label>
                      <span class="red--text">到付金额 *</span>
                    </template>
                  </v-text-field>
                  <v-menu ref="fee_pay_day" v-model="fee_pay_day" :close-on-content-click="false"
                    :return-value.sync="bulkForm.fee_pay_day" transition="scale-transition" min-width="auto" offset-y>
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="bulkForm.fee_pay_day" label="到付付款日期" append-icon="mdi-calendar" readonly
                        v-bind="attrs" v-on="on" dense outlined>
                      </v-text-field>
                    </template>
                    <v-date-picker v-model="bulkForm.fee_pay_day" no-title value="YYYY-mm-dd" scrollable locale="zh-cn"
                      @input="() => { $refs.fee_pay_day.save(bulkForm.fee_pay_day); fee_pay_day = false; }"></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col v-if="bulkForm.type === 3" cols="12">
                  <v-menu ref="receipt_pay_day" v-model="receipt_pay_day" :close-on-content-click="false"
                    :return-value.sync="bulkForm.receipt_pay_day" transition="scale-transition" min-width="auto"
                    offset-y>
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="bulkForm.receipt_pay_day" label="回单付款日期" append-icon="mdi-calendar"
                        readonly v-bind="attrs" v-on="on" dense outlined>
                      </v-text-field>
                    </template>
                    <v-date-picker v-model="bulkForm.receipt_pay_day" no-title value="YYYY-mm-dd" scrollable
                      locale="zh-cn"
                      @input="() => { $refs.receipt_pay_day.save(bulkForm.receipt_pay_day); receipt_pay_day = false; }"></v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn tile color="primary" @click="bulkupdatebill">保存</v-btn>
            <v-btn tile @click="cancelbulkupdate">关闭</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
    <v-dialog v-model="selfpaybillmodal" persistent max-width="400px">
      <v-form ref="selfpaybillform" v-model="selfpaybillvalid" lazy-validation>
        <v-card>
          <v-card-title class="grey lighten-4 pa-2 text-subtitle-1 mb-4 d-flex justify-space-between">
            生成应付账款
            <v-icon @click="selfpaybillmodal = false">mdi-close</v-icon>
          </v-card-title>
          <v-card-text>
            <v-container fluid>
              <v-row>
                <template v-if="username === 'root'">
                  <v-col cols="12">
                    <v-text-field v-model="selfpaybillform.billno" label="关联已有应付" dense outlined hide-details>
                    </v-text-field>
                  </v-col>
                </template>
                <template v-if="selfpaybillform.enabled">
                  <v-col cols="12">
                    <v-checkbox v-model="selfpaybillform.checked" label="支付运费" hide-details></v-checkbox>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field v-model="selfpaybillform.amount" label="运费" readonly
                      :disabled="!selfpaybillform.checked" dense outlined hide-details>
                    </v-text-field>
                  </v-col>
                </template>
                <template v-if="selfpaybillform.renabled">
                  <v-col cols="12">
                    <v-checkbox v-model="selfpaybillform.rchecked" label="支付押金" hide-details></v-checkbox>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field v-model="selfpaybillform.ramount" label="押金" readonly
                      :disabled="!selfpaybillform.rchecked" dense outlined hide-details>
                    </v-text-field>
                  </v-col>
                </template>
                <template v-if="selfpaybillform.oenabled">
                  <v-col cols="12">
                    <v-checkbox v-model="selfpaybillform.ochecked" label="支付油卡" hide-details></v-checkbox>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field v-model="selfpaybillform.oamount" label="油卡" readonly
                      :disabled="!selfpaybillform.ochecked" dense outlined hide-details>
                    </v-text-field>
                  </v-col>
                </template>
                <v-col cols="12">
                  <v-textarea v-model="selfpaybillform.remark" label="备注" rows="3" outlined></v-textarea>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn tile color="primary" :disabled="!selfpaybillvalid" @click="generatebill">生成</v-btn>
            <v-btn tile @click="selfpaybillmodal = false">关闭</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
    <UploadTask ref="uploadRef1" modelTitle="上传自营账单" uploadType="selfbill" />
    <UploadTask ref="uploadRef2" modelTitle="上传蜂羽账单" uploadType="fengyubill" />
  </v-container>
</template>

<script>
import _ from "underscore";
import { mapState } from "vuex";
import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
import UploadTask from "@/components/uploadtask.vue";
export default {
  name: "FinanceSelfBill",
  data() {
    return {
      locale,
      pages: [
        { text: "20/页", value: 20 },
        { text: "50/页", value: 50 },
        { text: "100/页", value: 100 },
        { text: "200/页", value: 200 },
        { text: '500/页', value: 500 },
        { text: '1000/页', value: 1000 },
        // { text: '1500/页', value: 1500 },
      ],
      queryForm: {
        nos: "",
        platform_no: "",
        day_type: "block_t",
        day_range: [],
        vehicle_type: undefined,
        vehicle_number: "",
        postroutelevel: undefined,
        transport_kind: undefined,
        postofficeid: undefined,
        postline: "",
        self_bill_state: undefined,
        corp: undefined,
        own_type: undefined,
        section: undefined,
      },
      vehicle_types: [],
      postoffices: [],
      self_bill_states: [],
      corps: [],
      own_types: [],
      sections: [],
      headers: [
        { dataIndex: "A", slots: { title: "AH" }, scopedSlots: { customRender: "A" }, width: 80, align: "center", fixed: 'left', },
        { dataIndex: "B", slots: { title: "BH" }, scopedSlots: { customRender: "B" }, width: 100, align: "center", fixed: 'left', },
        { dataIndex: "C", slots: { title: "CH" }, scopedSlots: { customRender: "C" }, width: 80, align: "center", fixed: 'left', },
        { dataIndex: "D", slots: { title: "DH" }, scopedSlots: { customRender: "D" }, width: 50, align: "center", fixed: 'left', },
        { dataIndex: "E", slots: { title: "EH" }, scopedSlots: { customRender: "E" }, width: 50, align: "center", fixed: 'left', },
        { dataIndex: "F", slots: { title: "FH" }, scopedSlots: { customRender: "F" }, width: 90, align: "center", fixed: 'left', },
        { dataIndex: "I", slots: { title: "IH" }, scopedSlots: { customRender: "I" }, width: 90, align: "center", fixed: 'left', },
        { dataIndex: "G", slots: { title: "GH" }, scopedSlots: { customRender: "G" }, width: 128, align: "center", },
        { dataIndex: "H", slots: { title: "HH" }, scopedSlots: { customRender: "H" }, width: 128, align: "center", },
        { dataIndex: "J", slots: { title: "JH" }, scopedSlots: { customRender: "J" }, width: 80, align: "center", },
        { dataIndex: "K", slots: { title: "KH" }, scopedSlots: { customRender: "K" }, width: 80, align: "center", },
        { dataIndex: "L", slots: { title: "LH" }, scopedSlots: { customRender: "L" }, width: 80, align: "center", },
        { dataIndex: "M0", slots: { title: "M0H" }, scopedSlots: { customRender: "M0" }, width: 100, align: "center", },
        { dataIndex: "M", slots: { title: "MH" }, scopedSlots: { customRender: "M" }, width: 100, align: "center", },
        { dataIndex: "N", slots: { title: "NH" }, scopedSlots: { customRender: "N" }, width: 80, align: "center", },
        { dataIndex: "O", slots: { title: "OH" }, scopedSlots: { customRender: "O" }, width: 60, align: "center", },
        { dataIndex: "P", slots: { title: "PH" }, scopedSlots: { customRender: "P" }, width: 70, align: "center", },
        { dataIndex: "Q", slots: { title: "QH" }, scopedSlots: { customRender: "Q" }, width: 75, align: "center", },
        { dataIndex: "R", slots: { title: "RH" }, scopedSlots: { customRender: "R" }, width: 70, align: "center", },
        { dataIndex: "S", slots: { title: "SH" }, scopedSlots: { customRender: "S" }, width: 75, align: "center", },
        { dataIndex: "T", slots: { title: "TH" }, scopedSlots: { customRender: "T" }, width: 75, align: "center", },
        { dataIndex: "U", slots: { title: "UH" }, scopedSlots: { customRender: "U" }, width: 70, align: "center", },
        { dataIndex: "V", slots: { title: "VH" }, scopedSlots: { customRender: "V" }, width: 60, align: "center", },
        { dataIndex: "W", slots: { title: "WH" }, scopedSlots: { customRender: "W" }, width: 75, align: "center", },
        { dataIndex: "X", slots: { title: "XH" }, scopedSlots: { customRender: "X" }, width: 75, align: "center", },
        { dataIndex: "Y", slots: { title: "YH" }, scopedSlots: { customRender: "Y" }, width: 75, align: "center", },
        { dataIndex: "Z", slots: { title: "ZH" }, scopedSlots: { customRender: "Z" }, width: 75, align: "center", },
        { dataIndex: "Z1", slots: { title: "Z1H" }, scopedSlots: { customRender: "Z1" }, width: 75, align: "center", },
        // { title: "付款信息", dataIndex: "pay_info", scopedSlots: { customRender: "pay_info" }, width: 80, align: "center", },
        // { title: "备注", dataIndex: "selfremark", scopedSlots: { customRender: "selfremark" }, width: 80, align: "center", },
        { title: "更新时间", dataIndex: "update_time", scopedSlots: { customRender: "update_time" }, width: 150, align: "center" },
        { title: "操作", dataIndex: "action", scopedSlots: { customRender: "action" }, width: 50, align: "center", fixed: "right", },
      ],
      page: 1,
      limit: 20,
      list: [],
      length: 0,
      count: 0,
      height: 600,
      uploadable: false,
      editable: false,
      vrules: {
        required: (value) => !!value || "不能为空"
      },
      billForm: {},
      billModel: false,
      bulkForm: {},
      bulkModel: false,
      platforms: [],
      oilcard_typedata: {},
      valid: true,
      oilcard_day: false,
      fee_request_day: false,
      fee_pay_day: false,
      receipt_return_day: false,
      receipt_request_day: false,
      receipt_pay_day: false,
      total_freight: null,
      selectedRowKeys: [],
      selfpaybillform: {
        waybillids: [],
        rwaybillids: [],
        owaybillids: [],
      },
      selfpaybillmodal: false,
      selfpaybillvalid: true,
      selfpaybilldatemenu: false,
      platformrateform: {},
      oilcardrateform: {},
    };
  },
  computed: {
    ...mapState(["role", "username"]),
    width() {
      return _.reduce(this.headers, (a, b) => a + (b.width || 300), 0);
    },
    oilcard_types() {
      let list = this.oilcard_typedata[this.billForm.platform];
      console.log(this.oilcard_typedata, this.billForm.platform, list);
      return list || [];
    },
    total_freight2() {
      if (this.selectedRowKeys.length === 0) return null;
      let total_freight = {
        real_freight_1: this.$d(),//自有成本
        real_freight_3: this.$d(),//包车成本
        real_freight2: this.$d(),//平台总价
        real_freight2_947: this.$d(),//平台总价（含税）
        oilcard_fee: this.$d(),//油卡金额
        oilcard_fee_947: this.$d(),//油卡金额（含税）
        delivery_discharge_fee: this.$d(),//卸货到付
        delivery_discharge_fee_947: this.$d(),//卸货到付（含税）
        receipt_deposit: this.$d(),//回单押金
        receipt_deposit_947: this.$d(),//回单押金（含税）
        check_amount2: this.$d(),//考核
      };
      for (let item of this.list) {
        if (this.selectedRowKeys.includes(item._id)) {
          let {
            own_type,
            real_freight2_947,
            oilcard_fee,
            oilcard_fee_947,
            delivery_discharge_fee,
            delivery_discharge_fee_947,
            receipt_deposit,
            receipt_deposit_947,
            real_freight2,
            check_amount2,
          } = item;
          if (own_type === 1) {//自有车
            total_freight.real_freight_1 = total_freight.real_freight_1.plus(real_freight2 || 0);
          }
          else if (own_type === 3) {//包车
            total_freight.real_freight_3 = total_freight.real_freight_3.plus(real_freight2 || 0);
          }
          else {
            total_freight.real_freight2 = total_freight.real_freight2.plus(real_freight2 || 0);
            total_freight.real_freight2_947 = total_freight.real_freight2_947.plus(real_freight2_947 || 0);
            total_freight.oilcard_fee = total_freight.oilcard_fee.plus(oilcard_fee);
            total_freight.oilcard_fee_947 = total_freight.oilcard_fee_947.plus(oilcard_fee_947 || oilcard_fee);
            total_freight.delivery_discharge_fee = total_freight.delivery_discharge_fee.plus(delivery_discharge_fee || 0);
            total_freight.delivery_discharge_fee_947 = total_freight.delivery_discharge_fee_947.plus(delivery_discharge_fee_947 || 0);
            total_freight.receipt_deposit = total_freight.receipt_deposit.plus(receipt_deposit || 0);
            total_freight.receipt_deposit_947 = total_freight.receipt_deposit_947.plus(receipt_deposit_947 || 0);
          }
          total_freight.check_amount2 = total_freight.check_amount2.plus(check_amount2 || 0);
        }
      }
      return {
        real_freight_1: this.$d(total_freight.real_freight_1.toFixed(2)).toString(),
        real_freight_3: this.$d(total_freight.real_freight_3.toFixed(2)).toString(),
        real_freight2: this.$d(total_freight.real_freight2.toFixed(2)).toString(),
        real_freight2_947: this.$d(total_freight.real_freight2_947.toFixed(2)).toString(),
        oilcard_fee: this.$d(total_freight.oilcard_fee.toFixed(2)).toString(),
        oilcard_fee_947: this.$d(total_freight.oilcard_fee_947.toFixed(2)).toString(),
        delivery_discharge_fee: this.$d(total_freight.delivery_discharge_fee.toFixed(2)).toString(),
        delivery_discharge_fee_947: this.$d(total_freight.delivery_discharge_fee_947.toFixed(2)).toString(),
        receipt_deposit: this.$d(total_freight.receipt_deposit.toFixed(2)).toString(),
        receipt_deposit_947: this.$d(total_freight.receipt_deposit_947.toFixed(2)).toString(),
        check_amount2: total_freight.check_amount2.toString(),
      };
    },
  },
  components: { UploadTask },
  watch: {
    '$route.query.nos'(nos) {
      if (nos) {
        this.queryForm.nos = (nos || "").split(',').join('\n');
        this.getdata();
      }
    },
    page() {
      this.getdata();
    },
    limit() {
      if (this.page !== 1) this.page = 1;
      else this.getdata();
    },
    'billForm.oilcard_fee'(oilcard_fee) {
      let { delivery_discharge_fee, receipt_deposit } = this.billForm;
      this.billForm.real_freight2 = this.$d(oilcard_fee || 0)
        .plus(delivery_discharge_fee || 0)
        .plus(receipt_deposit || 0).toString();
    },
    'billForm.delivery_discharge_fee'(delivery_discharge_fee) {
      let { oilcard_fee, receipt_deposit } = this.billForm;
      this.billForm.real_freight2 = this.$d(oilcard_fee || 0)
        .plus(delivery_discharge_fee || 0)
        .plus(receipt_deposit || 0).toString();
    },
    'billForm.receipt_deposit'(receipt_deposit) {
      let { oilcard_fee, delivery_discharge_fee } = this.billForm;
      this.billForm.real_freight2 = this.$d(oilcard_fee || 0)
        .plus(delivery_discharge_fee || 0)
        .plus(receipt_deposit || 0).toString();
    },
  },
  mounted() {
    this.height = window.innerHeight - 430;
    window.onresize = (e) => {
      console.log("onresize", window.innerHeight);
      this.height = window.innerHeight - 430;
    };
    this.page = 1;
    this.list = [];
    this.length = 0;
    let start_day = this.$dayjs().format("YYYY-MM-01");
    let end_day = this.$dayjs(new Date(`${start_day} 00:00:00.000+08:00`).getTime()).add(1, "month").subtract(1, 'second').format("YYYY-MM-DD");
    this.queryForm = {
      nos: (this.$route.query.nos || "").split(',').join('\n'),
      platform_no: "",
      day_type: "block_t",
      day_range: [start_day, end_day],
      vehicle_type: undefined,
      vehicle_number: "",
      postroutelevel: undefined,
      transport_kind: undefined,
      postofficeid: undefined,
      postline: "",
      self_bill_state: undefined,
      corp: undefined,
      own_type: undefined,
      section: undefined,
    };
    this.getdata();
  },
  methods: {
    getdata() {
      this.selectedRowKeys = [];
      this.oilcardrateform = {};
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/selfbill/list", { page: this.page, limit: this.limit, ...this.queryForm }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.uploadable = res.data.uploadable;
          this.editable = res.data.editable;
          this.list = res.data.list.map(n => {
            if (n.platform_rate) {
              n.platform_rate = this.$d(1).minus(n.platform_rate).times(100);
            }
            if (n.oilcard_rate) {
              n._oilcard_rate = this.$d(n.oilcard_rate).times(100);
            }
            if (n.real_freight2) {
              n._real_freight2 = this.$d(this.$d(n.real_freight2).toFixed(2)).toString();
            }
            if (n.real_freight2_947) {
              n._real_freight2_947 = this.$d(this.$d(n.real_freight2_947).toFixed(2)).toString();
            }
            if (n.delivery_discharge_fee) {
              n._delivery_discharge_fee = this.$d(this.$d(n.delivery_discharge_fee).toFixed(2)).toString();
            }
            if (n.delivery_discharge_fee_947) {
              n._delivery_discharge_fee_947 = this.$d(this.$d(n.delivery_discharge_fee_947).toFixed(2)).toString();
            }
            if (n.receipt_deposit) {
              n._receipt_deposit = this.$d(this.$d(n.receipt_deposit).toFixed(2)).toString();
            }
            if (n.receipt_deposit_947) {
              n._receipt_deposit_947 = this.$d(this.$d(n.receipt_deposit_947).toFixed(2)).toString();
            }
            return {
              ...n,
            };
          });
          this.length = res.data.length;
          this.count = res.data.count;
          if (this.length > 0 && this.page > this.length) this.page = 1;
          this.vehicle_types = res.data.vehicle_types;
          this.postoffices = res.data.postoffices;
          this.self_bill_states = res.data.self_bill_states;
          this.corps = res.data.corps;
          this.own_types = res.data.own_types;
          this.sections = res.data.sections;
          this.total_freight = res.data.total_freight;
        }
        else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    download() {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/selfbill/download", { ...this.queryForm, action: 'download' }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.$download(res.data.url, res.data.name);
        }
        else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    download2() {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/selfbill/download", { ...this.queryForm, action: 'download2' }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.$download(res.data.url, res.data.name);
        }
        else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    showedit(item) {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/selfbill/info", { _id: item._id }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.platforms = res.data.platforms;
          this.oilcard_typedata = res.data.oilcard_typedata;
          this.billForm = res.data.billForm;
          this.billModel = true;
        }
        else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    unlock(_id) {
      this.update(_id, 'editable', true);
    },
    update(_id, key, value) {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/selfbill/update2", { _id, key, value }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.getdata();
        }
        else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    updatebill() {
      if (!this.$refs.form.validate()) return;
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/selfbill/update", { billForm: this.billForm }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.billModel = false;
          this.getdata();
        }
        else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    cancelupdate() {
      this.$refs.form.resetValidation();
      this.billModel = false;
    },
    showbulkedit(type) {
      if (!this.selectedRowKeys?.length) return;
      let fee = this.$d();
      let items = this.list.filter(n => this.selectedRowKeys.includes(n._id));
      if (type === 1) {//油卡
        items.forEach(n => {
          fee = fee.plus(n.oilcard_fee_947 || n.oilcard_fee || 0);
        });
      }
      else if (type === 2) {//到付款
        items.forEach(n => {
          fee = fee.plus(n.delivery_discharge_fee_947 || n.delivery_discharge_fee || 0);
        });
      }
      this.bulkForm = {
        ids: this.selectedRowKeys,
        type,
        oilcard_day: "",
        // fee_request_day: "",
        fee_pay_day: "",
        // receipt_request_day: "",
        receipt_pay_day: "",
        fee: fee.toFixed(2),
      };
      this.bulkModel = true;
    },
    bulkupdatebill() {
      if (!this.$refs.bulkform.validate()) return;
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/selfbill/bulkupdate", { dataForm: this.bulkForm }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.bulkModel = false;
          this.getdata();
        }
        else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    cancelbulkupdate() {
      this.$refs.bulkform.resetValidation();
      this.bulkModel = false;
    },
    changePlatform(v) {
      if (v === '其他') {
        this.billForm.platform_name = "线下支付";
        this.billForm.platform_rate = "1";
      }
    },
    editPlatformRate(record) {
      this.platformrateform = {
        _id: record._id,
        platform_rate: record.platform_rate
      };
    },
    savePlatformRate() {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/selfbill/saveplatformrate", this.platformrateform).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.getdata();
          this.platformrateform = {};
        }
        else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    cancelSavePlatformRate() {
      this.platformrateform = {};
    },
    editOilcardRate(record) {
      this.oilcardrateform = {
        _id: record._id,
        oilcard_type: record.oilcard_type
      };
    },
    saveOilcardRate() {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/selfbill/saveoilcardrate", this.oilcardrateform).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.getdata();
          this.oilcardrateform = {};
        }
        else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    cancelSaveOilcardRate() {
      this.oilcardrateform = {};
    },
    savepaytarget(item) {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/selfbill/savepaytarget", item).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.getdata();
        }
        else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    ///生成自营应付账款（通过第三方平台支付）
    makepayable() {
      if (this.selectedRowKeys.length === 0) return this.$toast.fail("未选择账单");
      let waybillids = this.selectedRowKeys.filter(n => {
        return this.list.find(m => m._id === n)?.generateable;
      });
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/selfbill/calcpaybill", { waybillids }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.selfpaybillform = res.data.selfpaybillform;
          this.selfpaybillmodal = true;
        }
        else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    generatebill() {
      if (!this.$refs.selfpaybillform.validate()) return;
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/selfbill/generatepaybill", { ...this.selfpaybillform, v: "2" }).then((res) => {
        if (res.code === 0) {
          this.$toast.success("已生成");
          this.selfpaybillmodal = false;
        }
        else {
          this.$toast.clear();
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    }
  },
};
</script>
<style lang="less" scoped>
/deep/ .ant-form-item {
  margin-bottom: unset;
}

/deep/ .row {
  margin-bottom: 0 !important;
}

/deep/ .row+.row {
  margin-top: 0;
}

/deep/ .col,
.col-12 {
  padding-bottom: 0 !important;
}

/deep/ .ant-table-fixed-header .ant-table-scroll .ant-table-header {
  padding-bottom: 4px !important;
}

/deep/ .ant-table-small>.ant-table-content>.ant-table-fixed-left>.ant-table-header>table>.ant-table-thead>tr>th {
  padding: 0 !important;
}

/deep/ .ant-table-small>.ant-table-content>.ant-table-fixed-left>.ant-table-body-outer>.ant-table-body-inner>table>.ant-table-tbody>tr>td {
  padding: 0 !important;
}

/deep/ .ant-table-small>.ant-table-content>.ant-table-scroll>.ant-table-header>table>.ant-table-thead>tr>th {
  padding: 0 !important;
}

/deep/ .ant-table-small>.ant-table-content>.ant-table-scroll>.ant-table-body>table>.ant-table-tbody>tr>td {
  padding: 0 !important;
}

p {
  margin: 0;
}
</style>